var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMegaphone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.68 19.43L23.47 28.89C28.56 26.45 34.15 25.86 39.39 26.91L26.68 6.15C25.23 11.3 22.17 16 17.68 19.43Z",
    fill: "#0F0F0F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.82 25.83L29.65 2.7C29.23 2.01 28.33 1.8 27.64 2.22C26.95 2.64 26.74 3.54 27.16 4.23L41.33 27.36C41.75 28.05 42.65 28.26 43.34 27.84C44.03 27.42 44.24 26.52 43.82 25.83Z",
    fill: "#0F0F0F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.67 11.24C40.48 9.3 37.95 8.69 36.01 9.88L40.31 16.9C42.25 15.71 42.86 13.18 41.67 11.24Z",
    fill: "#0F0F0F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.36999 29.36C3.91999 29.92 3.86999 30.7 4.24999 31.31L6.78999 35.46C7.15999 36.07 7.87999 36.38 8.58999 36.24L10.3 35.88L5.46999 28L4.36999 29.37V29.36Z",
    fill: "#0F0F0F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.07 33.01L21.71 32C22.51 31.51 22.76 30.46 22.27 29.66L16.44 20.14C15.95 19.34 14.9 19.09 14.1 19.58L6.73998 24.09C5.93998 24.58 5.68998 25.63 6.17998 26.43L12.01 35.95C12.48 36.71 13.45 36.98 14.23 36.58C14.27 36.56 14.31 36.54 14.35 36.52L17.43 34.63C17.76 34.43 18.2 34.53 18.41 34.86C18.61 35.19 18.51 35.63 18.18 35.84L15.21 37.66L22.57 45.02C23.88 46.33 26.01 46.33 27.32 45.02C28.63 43.71 28.63 41.58 27.32 40.27L20.07 33.02V33.01Z",
    fill: "#0F0F0F"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMegaphone);
export default __webpack_public_path__ + "static/media/Megaphone.25d60b26.svg";
export { ForwardRef as ReactComponent };